import * as fromDatatype from '../datatype-library/index';

export interface app_message_comment_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  app_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  ref_type: fromDatatype.VarcharDatatypeInterface;
  ref_table: fromDatatype.VarcharDatatypeInterface;
  ref_column: fromDatatype.VarcharDatatypeInterface;
  ref_row: fromDatatype.VarcharDatatypeInterface;
  value_type: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_rating: fromDatatype.IntegerDatatypeInterface;
  value_emotion: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_message_comment_RowClass implements app_message_comment_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  app_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  ref_type: fromDatatype.VarcharDatatypeInterface;
  ref_table: fromDatatype.VarcharDatatypeInterface;
  ref_column: fromDatatype.VarcharDatatypeInterface;
  ref_row: fromDatatype.VarcharDatatypeInterface;
  value_type: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_rating: fromDatatype.IntegerDatatypeInterface;
  value_emotion: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


